import React, { useEffect, createElement } from 'react';
import { WarningBanner } from './WarningBanner';
import { CTAButton } from './CTAButton';
import { TestimonialCard } from './TestimonialCard';
export function Advertorial() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://pixel.wetracked.io/ppt.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return <div className="max-w-md mx-auto bg-white text-gray-800 pb-10" data-id="element-6">
      {/* Header */}
      <header className="bg-white sticky top-0 z-10 border-b border-gray-200 shadow-sm" data-id="element-7">
        <div className="px-4 py-3" data-id="element-8">
          <div className="flex items-center justify-between" data-id="element-9">
            <h1 className="text-lg font-bold text-red-600" data-id="element-10">URGENT WARNING</h1>
            <div className="text-sm text-gray-500" data-id="element-11">487,322 views</div>
          </div>
        </div>
      </header>
      {/* Main Content */}
      <main className="px-4" data-id="element-12">
        {/* Title Section */}
        <div className="mt-6" data-id="element-13">
          <h2 className="text-2xl font-bold leading-tight text-gray-900" data-id="element-14">
            If You're Taking A GLP-1 (Ozempic, Wegovy, Mounjaro), You NEED To
            See This Before Your Next Dose
          </h2>
          <div className="mt-2 text-sm text-gray-600" data-id="element-15">
            By Jessica Torres | Independent Health Investigations
            <br data-id="element-16" />
            Posted: November 9, 2025
          </div>
        </div>
        {/* Warning Banner */}
        <WarningBanner text="THIS AFFECTS EVERY SINGLE GLP-1 USER" data-id="element-17" />
        <p className="mt-4 text-base" data-id="element-18">
          Here's what your doctor didn't tell you when they handed you that
          prescription:
        </p>
        <p className="mt-4 text-lg font-medium italic" data-id="element-19">
          While the weight is coming off, something else is disappearing too.
          Something you can't afford to lose.
        </p>
        {/* Breaking Research Alert */}
        <div className="mt-6 bg-red-50 border-l-4 border-red-600 p-4" data-id="element-20">
          <p className="font-bold text-red-700" data-id="element-21">🚨 BREAKING RESEARCH:</p>
          <p className="mt-1" data-id="element-22">
            Harvard scientists confirm up to 30% of weight lost on GLP-1
            medications is MUSCLE, not fat—and it's happening to EVERYONE on
            these drugs, not just some people
          </p>
        </div>
        {/* Introduction */}
        <div className="mt-6" data-id="element-23">
          <p className="text-base" data-id="element-24">
            My name is Jessica Torres, and I'm an independent health journalist
            who's spent the last 18 months investigating what's being called
            "the hidden GLP-1 crisis."
          </p>
          <p className="mt-4 text-base" data-id="element-25">
            What I uncovered shocked me—and it's going to shock you too.
          </p>
          <p className="mt-4 text-base" data-id="element-26">
            The pharmaceutical companies selling these medications KNOW about
            this problem. The doctors prescribing them often DON'T. And you're
            caught in the middle, watching your muscle disappear along with the
            fat.
          </p>
          <p className="mt-4 text-base" data-id="element-27">
            But here's what really made my blood boil:
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-28">
            The solution has existed for over 20 years. It's backed by dozens of
            peer-reviewed studies. Professional athletes use it religiously.
          </p>
          <p className="mt-4 text-base" data-id="element-29">
            But pharma companies have kept it buried because there's no money in
            solving a problem they're profiting from.
          </p>
          <p className="mt-4 text-base font-bold" data-id="element-30">
            Until now. Because I'm about to blow the lid off this entire scheme.
          </p>
        </div>
        {/* Time Bomb Section */}
        <div className="mt-8" data-id="element-31">
          <h3 className="text-xl font-bold text-red-600" data-id="element-32">
            ⏰ THE TICKING TIME BOMB EVERY GLP-1 USER FACES:
          </h3>
          <p className="mt-4 text-base" data-id="element-33">
            Right now—this very second—your body is breaking down muscle tissue
            for energy. It's been happening since you started your medication.
            And with every pound you lose, the problem accelerates.
          </p>
          <div className="mt-4 bg-yellow-50 p-4 rounded-lg" data-id="element-34">
            <p className="font-bold" data-id="element-35">
              By month 6, most GLP-1 users have lost 15-20 pounds of MUSCLE.
            </p>
            <p className="mt-2 font-bold" data-id="element-36">
              By month 12? Some have lost 30+ pounds of muscle.
            </p>
          </div>
          <p className="mt-4 text-base" data-id="element-37">
            That's not just numbers on a scan. That's your metabolism. Your
            strength. Your independence. Your ability to keep the weight off
            permanently.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-38">
            And once it's gone, it takes YEARS to rebuild—if you can rebuild it
            at all.
          </p>
        </div>
        {/* Cover-Up Section */}
        <div className="mt-8" data-id="element-39">
          <h3 className="text-xl font-bold" data-id="element-40">
            The $10 Billion Cover-Up Nobody's Talking About
          </h3>
          <p className="mt-4 text-base" data-id="element-41">
            First, let me show you exactly how they've been lying to you.
          </p>
          <div className="mt-4 bg-gray-50 p-4 rounded-lg" data-id="element-42">
            <p className="font-medium" data-id="element-43">
              WHAT THEY TOLD YOU: "Take this medication and you'll lose weight
              safely and effectively."
            </p>
            <p className="mt-2 text-center text-red-600 font-bold text-xl" data-id="element-44">
              ❌
            </p>
            <p className="mt-2 font-medium" data-id="element-45">
              THE REALITY: "Take this medication and you'll lose weight—but 30%
              of it will be muscle, destroying your metabolism and setting you
              up to gain it all back (so you'll need our drug forever)."
            </p>
          </div>
          <p className="mt-6 text-base" data-id="element-46">
            Let me be blunt: GLP-1 medications are a pharmaceutical goldmine.
            These companies are making BILLIONS every quarter.
          </p>
          <p className="mt-4 text-base" data-id="element-47">
            Do you really think they want you to know that their miracle drug is
            destroying your muscle mass?
          </p>
          <p className="mt-4 text-base" data-id="element-48">
            That while you're celebrating the number on the scale, your body is
            literally eating itself alive?
          </p>
        </div>
        {/* Testimonial */}
        <TestimonialCard quote="My doctor never mentioned muscle loss. Never. They just kept celebrating my weight loss and increasing my dose. By month 8, I couldn't carry my own laundry basket up the stairs. I'm 51 years old—I shouldn't feel like I'm 80." author="Michelle K., San Diego, CA" data-id="element-49" />
        {/* What They're Not Telling You */}
        <div className="mt-8" data-id="element-50">
          <h3 className="text-xl font-bold text-red-600" data-id="element-51">
            ⚠️ HERE'S WHAT THEY'RE NOT TELLING YOU:
          </h3>
          <p className="mt-4 text-base font-medium" data-id="element-52">
            When you lose muscle on GLP-1s, your metabolism tanks. When your
            metabolism tanks, you become DEPENDENT on the medication forever—or
            you gain all the weight back (plus more) when you stop.
          </p>
          <p className="mt-4 text-base" data-id="element-53">
            It's the perfect business model for them. A nightmare for you.
          </p>
        </div>
        {/* What's Happening To Your Body */}
        <div className="mt-8" data-id="element-54">
          <h3 className="text-xl font-bold" data-id="element-55">
            What's ACTUALLY Happening To Your Body Right Now
          </h3>
          <p className="mt-4 text-base" data-id="element-56">
            Here's the brutal truth about GLP-1 medications:
          </p>
          <p className="mt-4 text-base" data-id="element-57">
            They suppress your appetite so aggressively that most users can
            barely eat 800-1,000 calories per day. Some can't even hit 600.
          </p>
          <p className="mt-4 text-base" data-id="element-58">
            Your body needs energy to function. When it doesn't get enough from
            food, it looks elsewhere.
          </p>
          <p className="mt-4 text-base" data-id="element-59">
            Fat? Yes, it burns fat. But here's what they don't tell you:
          </p>
          <div className="mt-4 bg-red-50 p-4 rounded-lg" data-id="element-60">
            <p className="font-bold" data-id="element-61">
              YOUR BODY IS ALSO BREAKING DOWN YOUR MUSCLE FOR ENERGY 24 hours a
              day. 7 days a week. Even while you sleep.
            </p>
          </div>
          <p className="mt-4 text-base" data-id="element-62">
            This process is called "muscle protein breakdown" or proteolysis.
          </p>
          <p className="mt-4 text-base" data-id="element-63">
            And in the extreme caloric deficits created by GLP-1 medications,
            the rate of muscle breakdown EXCEEDS the rate of muscle building—no
            matter how much protein you try to eat.
          </p>
        </div>
        {/* Protein Shakes Don't Work */}
        <div className="mt-8" data-id="element-64">
          <h3 className="text-xl font-bold" data-id="element-65">
            Stop Wasting Money On Protein Shakes That Don't Work
          </h3>
          <p className="mt-4 text-base" data-id="element-66">
            I've talked to hundreds of GLP-1 users who spent THOUSANDS on
            protein powders, bars, and supplements.
          </p>
          <p className="mt-4 text-base" data-id="element-67">
            Every single one told me the same thing:
          </p>
          <p className="mt-4 text-base italic" data-id="element-68">
            "I can't stomach them. The texture makes me gag. I feel sick for
            hours. And they're not even working."
          </p>
        </div>
        {/* Why Protein Doesn't Save You - Moved up */}
        <div className="mt-8 bg-gray-50 p-4 rounded-lg" data-id="element-69">
          <h4 className="font-bold" data-id="element-70">Why protein shakes don't save you:</h4>
          <ul className="mt-2 list-disc pl-5 space-y-2" data-id="element-71">
            <li data-id="element-72">You need 100+ grams of protein daily to maintain muscle</li>
            <li data-id="element-73">That's 400-500+ calories JUST from protein</li>
            <li data-id="element-74">But you can barely tolerate 800-1,000 calories TOTAL</li>
            <li data-id="element-75">
              Heavy protein shakes are difficult to consume in severe caloric
              deficit
            </li>
            <li data-id="element-76">Even if you could force it down, the math doesn't work</li>
          </ul>
        </div>
        {/* Wrong Problem Explanation - Moved down */}
        <div className="mt-8" data-id="element-77">
          <p className="text-base" data-id="element-78">
            That's because protein shakes are solving the WRONG problem.
          </p>
          <p className="mt-4 text-base" data-id="element-79">
            Protein gives your body building blocks. But when your body is in
            demolition mode—actively breaking down muscle faster than you can
            build it—more building blocks don't help.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-80">
            You need to STOP THE DEMOLITION. Not just bring in more materials.
          </p>
          <p className="mt-4 text-base italic" data-id="element-81">
            Your doctor's advice to "eat more protein" is useless when you're
            physically incapable of doing so.
          </p>
          <p className="mt-4 text-base" data-id="element-82">
            And frankly? If your doctor is still telling you to "just eat more
            protein," they're either ignorant or they don't care.
          </p>
        </div>
        {/* Effects of Muscle Loss */}
        <div className="mt-8" data-id="element-83">
          <p className="text-base" data-id="element-84">Meanwhile, as you lose muscle:</p>
          <ul className="mt-2 list-disc pl-5 space-y-2" data-id="element-85">
            <li data-id="element-86">
              Your metabolism crashes (muscle burns 3x more calories than fat)
            </li>
            <li data-id="element-87">You get weaker and weaker</li>
            <li data-id="element-88">Your face hollows out (the dreaded "Ozempic face")</li>
            <li data-id="element-89">Your butt and curves disappear</li>
            <li data-id="element-90">You set yourself up for massive weight regain</li>
          </ul>
        </div>
        {/* Rebound Effect */}
        <div className="mt-8 bg-yellow-50 p-4 rounded-lg" data-id="element-91">
          <h4 className="font-bold" data-id="element-92">THE REBOUND EFFECT:</h4>
          <p className="mt-2 text-base" data-id="element-93">
            Studies show that people who lose significant muscle during weight
            loss regain weight FASTER and in GREATER amounts than those who
            preserved their muscle. Why? Because a slower metabolism means your
            body needs fewer calories—so the same diet that maintained your
            weight before will now make you gain.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-94">
            You'll be trapped on GLP-1s forever, or you'll watch the weight come
            screaming back.
          </p>
        </div>
        {/* The Solution */}
        <div className="mt-8" data-id="element-95">
          <h3 className="text-xl font-bold text-red-600" data-id="element-96">
            ⚠️ THE SOLUTION EXISTS (But Big Pharma Doesn't Want You To Know)
          </h3>
          <h4 className="mt-4 font-bold" data-id="element-97">
            The "Underground" Compound Bodybuilders Have Hidden For Decades
          </h4>
          <p className="mt-4 text-base" data-id="element-98">
            Here's where this story gets interesting.
          </p>
          <p className="mt-4 text-base" data-id="element-99">
            Professional bodybuilders—the people who get paid to have perfect
            physiques—have been using a compound called HMB (Beta-Hydroxy
            Beta-Methylbutyrate) since the 1990s.
          </p>
          <p className="mt-4 text-base" data-id="element-100">Why?</p>
          <p className="mt-4 text-base" data-id="element-101">
            Because when they're cutting for competition—eating extremely low
            calories to get shredded—they need to protect their muscle at all
            costs.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-102">
            HMB is their secret weapon.
          </p>
        </div>
        {/* How HMB Works */}
        <div className="mt-8 bg-blue-50 p-4 rounded-lg" data-id="element-103">
          <h4 className="font-bold" data-id="element-104">Here's how it works:</h4>
          <p className="mt-2 text-base" data-id="element-105">
            PROTEIN = Brings in building materials (But requires you to eat a
            ton of food)
          </p>
          <p className="mt-4 text-center text-blue-600 font-bold text-xl" data-id="element-106">⚡</p>
          <p className="mt-4 text-base" data-id="element-107">
            HMB = STOPS your body from tearing down muscle (Works even when you
            can barely eat anything)
          </p>
        </div>
        <p className="mt-6 text-base" data-id="element-108">
          HMB works by blocking the cellular pathways that break down muscle. It
          literally turns OFF the breakdown signal.
        </p>
        <p className="mt-4 text-base" data-id="element-109">
          The analogy that finally made this click for me:
        </p>
        <div className="mt-4 bg-gray-50 p-4 rounded-lg" data-id="element-110">
          <p className="text-base italic" data-id="element-111">
            Imagine your house is being demolished. Protein is like ordering
            more lumber—but the wrecking crew is destroying your house faster
            than you can rebuild it. HMB fires the wrecking crew. It STOPS the
            demolition. So even with limited lumber (protein), your house stays
            standing.
          </p>
        </div>
        <p className="mt-6 text-base" data-id="element-112">
          Multiple clinical studies—real peer-reviewed research, not marketing
          fluff—show that 3 grams of HMB per day preserves lean muscle mass
          during severe caloric restriction.
        </p>
        <p className="mt-4 text-base font-medium" data-id="element-113">
          This is EXACTLY the situation GLP-1 users are in.
        </p>
        {/* Why Doctors Don't Tell You */}
        <div className="mt-8" data-id="element-114">
          <h3 className="text-xl font-bold text-red-600" data-id="element-115">
            🚨 SO WHY HASN'T YOUR DOCTOR TOLD YOU ABOUT THIS?
          </h3>
          <p className="mt-4 text-base" data-id="element-116">Two reasons:</p>
          <ol className="mt-2 list-decimal pl-5 space-y-2" data-id="element-117">
            <li data-id="element-118">
              They don't know. Sports nutrition isn't taught in medical school.
              Your doctor knows how to prescribe Ozempic, but they have no idea
              how to protect you from its side effects.
            </li>
            <li data-id="element-119">
              Pharma companies don't promote it. There's no money in telling you
              about a supplement that solves the problem their expensive drug
              creates. Think about it.
            </li>
          </ol>
        </div>
        {/* Why Cheap Pills Don't Work */}
        <div className="mt-8" data-id="element-120">
          <h3 className="text-xl font-bold" data-id="element-121">
            But Here's Why Trying Cheap HMB Pills First Is The Biggest Mistake
            You Can Make
          </h3>
          <p className="mt-4 text-base" data-id="element-122">
            When I first learned about HMB, I was excited. Finally—a real
            solution!
          </p>
          <p className="mt-4 text-base" data-id="element-123">
            I immediately ordered the top-rated HMB supplements online.
          </p>
          <p className="mt-4 text-base" data-id="element-124">
            And within 48 hours, I understood why most people fail with HMB.
          </p>
          <p className="mt-4 text-base" data-id="element-125">
            Pills only deliver 60-70% of the HMB compound. The rest gets
            destroyed by stomach acid before it reaches your muscles. That means
            30-40% of what you paid for gets flushed down the toilet. Literally.
          </p>
          <p className="mt-4 text-base" data-id="element-126">
            Plus, to hit the clinical 3-gram dose, you need to swallow 4-6 large
            capsules daily. And powder? Even worse—chalky, gritty texture that's
            unbearable to drink.
          </p>
          <p className="mt-4 text-base" data-id="element-127">Most HMB products come as:</p>
          <ul className="mt-2 list-disc pl-5 space-y-2" data-id="element-128">
            <li data-id="element-129">
              Large capsules — Need 4-6 per day to hit clinical dose, only
              60-70% absorbed
            </li>
            <li data-id="element-130">Chalky powder — Thick, gritty texture, same poor absorption</li>
            <li data-id="element-131">
              Mixed into protein powder — Defeats the purpose when you can't
              stomach heavy shakes
            </li>
          </ul>
          <p className="mt-4 text-base" data-id="element-132">
            I know what you're thinking: "I'll try cheap pills first and upgrade
            later if they work."
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-133">
            Here's the problem: You can't afford the time.
          </p>
          <p className="mt-4 text-base" data-id="element-134">
            Most GLP-1 users quit pills within 2-3 weeks because they can't take
            them consistently. Meanwhile, they lose 3-5 more pounds of MUSCLE
            during those wasted weeks. Muscle they'll never get back.
          </p>
          <p className="mt-4 text-base" data-id="element-135">
            Plus, even when they ARE taking pills, only 60-70% gets absorbed.
            The rest is wasted.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-136">
            Every day without muscle protection, you're losing muscle.
            Permanently.
          </p>
          <div className="mt-6 bg-yellow-50 border-l-4 border-yellow-600 p-4" data-id="element-137">
            <h4 className="font-bold text-lg" data-id="element-138">The real cost breakdown:</h4>
            <div className="mt-3 space-y-3" data-id="element-139">
              <p className="text-base" data-id="element-140">
                <span className="text-red-600 font-medium" data-id="element-141">❌ Cheap pills</span>{' '}
                + 3 wasted weeks + permanent muscle loss ={' '}
                <span className="font-bold" data-id="element-142">EXPENSIVE</span>
              </p>
              <p className="text-base" data-id="element-143">
                <span className="text-green-600 font-medium" data-id="element-144">
                  ✅ Effective liquid
                </span>{' '}
                + immediate protection + preserved muscle ={' '}
                <span className="font-bold" data-id="element-145">WORTH IT</span>
              </p>
            </div>
          </div>
          <p className="mt-6 text-base" data-id="element-146">
            The science works. HMB DOES protect muscle during extreme caloric
            deficits.
          </p>
          <p className="mt-4 text-base" data-id="element-147">
            But pills waste 40% of the compound, and most people can't take them
            consistently.
          </p>
          <p className="mt-4 text-base" data-id="element-148">
            This is why the solution to muscle loss on GLP-1s has been hiding in
            plain sight—the delivery method has always been broken.
          </p>
          <p className="mt-4 text-base font-bold" data-id="element-149">Until now.</p>
        </div>
        {/* The Liquid Solution */}
        <div className="mt-8" data-id="element-150">
          <h3 className="text-xl font-bold text-blue-600" data-id="element-151">
            The Liquid Breakthrough That's Changing Everything
          </h3>
          <p className="mt-4 text-base" data-id="element-152">
            After months of investigation, I stumbled across something that
            changed everything.
          </p>
          <p className="mt-4 text-base" data-id="element-153">
            A small supplement company—not affiliated with Big Pharma—had
            created something revolutionary:
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-154">
            A concentrated LIQUID HMB formula with superior absorption—no pills
            or powder needed.
          </p>
        </div>
        {/* Product Benefits */}
        <div className="mt-6 bg-blue-50 p-4 rounded-lg" data-id="element-155">
          <h4 className="font-bold" data-id="element-156">Here's what makes it different:</h4>
          <ul className="mt-2 space-y-2" data-id="element-157">
            <li className="flex items-start" data-id="element-158">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-159"></span>
              <span data-id="element-160">
                Zero calories — Doesn't use up your limited calorie "budget"
              </span>
            </li>
            <li className="flex items-start" data-id="element-161">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-162"></span>
              <span data-id="element-163">Zero taste — Completely flavorless, odorless</span>
            </li>
            <li className="flex items-start" data-id="element-164">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-165"></span>
              <span data-id="element-166">
                Zero texture — Thin as water, no thickness or chalkiness
              </span>
            </li>
            <li className="flex items-start" data-id="element-167">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-168"></span>
              <span data-id="element-169">
                No pills to swallow — Just squeeze 1 dropper into any drink
              </span>
            </li>
            <li className="flex items-start" data-id="element-170">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-171"></span>
              <span data-id="element-172">
                Full clinical dose — 3 grams of HMB per serving (the exact
                amount proven effective)
              </span>
            </li>
            <li className="flex items-start" data-id="element-173">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-174"></span>
              <span data-id="element-175">
                Takes 5 seconds — Easier than adding cream to your coffee
              </span>
            </li>
          </ul>
        </div>
        <p className="mt-6 text-base font-medium" data-id="element-176">
          This is the game-changer GLP-1 users have been desperate for.
        </p>
        <p className="mt-4 text-base" data-id="element-177">
          One dropper in your morning coffee. That's it. You don't taste it. You
          don't feel it. But your body gets 24/7 protection against muscle
          breakdown.
        </p>
        <p className="mt-4 text-base" data-id="element-178">
          And here's the game-changer: Sublingual liquid absorption delivers
          90-95% bioavailability vs only 60-70% from pills.
        </p>
        <p className="mt-4 text-base" data-id="element-179">
          That means more of the active compound actually reaches your
          muscles—fast. Liquid absorbs in 60 seconds through your mouth's mucous
          membranes. Pills take 45+ minutes and lose 30-40% to stomach acid.
        </p>
        <p className="mt-4 text-base font-medium" data-id="element-180">
          You're not just getting a more convenient format. You're getting a
          more effective one.
        </p>
        {/* Section Break */}
        <div className="mt-10 mb-8 border-t-2 border-gray-200" data-id="element-181"></div>
        <h3 className="text-xl font-bold" data-id="element-182">Real Users, Real Results</h3>
        {/* Testimonials */}
        <div className="mt-6" data-id="element-183">
          <p className="text-base" data-id="element-184">
            When I first tried it myself, I was skeptical. "There's no way this
            is that simple," I thought.
          </p>
          <p className="mt-4 text-base" data-id="element-185">
            But after using it for just 2 weeks, I noticed something: I wasn't
            losing strength. My workouts felt normal. I could carry heavy
            grocery bags without getting exhausted.
          </p>
          <p className="mt-4 text-base" data-id="element-186">
            And I was still losing weight on the scale.
          </p>
          <p className="mt-4 text-base font-medium" data-id="element-187">
            I was losing FAT, not MUSCLE.
          </p>
        </div>
        <TestimonialCard quote="I couldn't believe how easy it was. Just 1 dropper in my coffee every morning. I don't taste it. I don't feel it. But after 8 weeks, my DEXA scan showed I'd lost 14 pounds of FAT and actually GAINED a pound of muscle. My trainer couldn't believe it." author="Jennifer M., 52, Phoenix, AZ" data-id="element-188" />
        <TestimonialCard quote="I tried HMB pills before and gagged on them every time. Protein shakes made my nausea worse. But this liquid formula? I literally can't even tell I'm taking it. It's been 3 months and I haven't missed a single day. My face has filled back out and I finally have my energy back." author="David R., 48, Portland, OR" data-id="element-189" />
        {/* CTA #1 - After Testimonials */}
        <div className="mt-8" data-id="element-190">
          <CTAButton text="PROTECT YOUR MUSCLE WITH LIQUID HMB NOW ►" data-id="element-191" />
          <p className="mt-4 text-sm text-center text-gray-600" data-id="element-192">
            Join thousands seeing real results with this breakthrough formula.
          </p>
        </div>
        {/* Final CTA Section */}
        <div className="mt-10" data-id="element-193">
          <h3 className="text-xl font-bold" data-id="element-194">
            Don't Let Pharma Giants Steal Your Transformation
          </h3>
          <p className="mt-4 text-base" data-id="element-195">
            You didn't come this far just to end up weak, gaunt, and dependent
            on expensive medications forever.
          </p>
          <p className="mt-4 text-base" data-id="element-196">You deserve to:</p>
          <ul className="mt-2 list-disc pl-5 space-y-2" data-id="element-197">
            <li data-id="element-198">Lose FAT while keeping your MUSCLE</li>
            <li data-id="element-199">Look healthy and vibrant, not sick and frail</li>
            <li data-id="element-200">Maintain your strength and independence</li>
            <li data-id="element-201">Build a transformation that actually LASTS</li>
          </ul>
        </div>
        <div className="mt-6" data-id="element-202">
          <p className="text-base" data-id="element-203">
            The liquid HMB solution I've been investigating delivers exactly
            that. Here's what makes it different from everything else you've
            tried:
          </p>
          <ul className="mt-2 space-y-2" data-id="element-204">
            <li className="flex items-start" data-id="element-205">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-206"></span>
              <span data-id="element-207">
                Clinically proven mechanism — Blocks muscle breakdown at the
                cellular level
              </span>
            </li>
            <li className="flex items-start" data-id="element-208">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-209"></span>
              <span data-id="element-210">
                Liquid format breakthrough — Superior bioavailability (90-95%
                absorption) and effortless to use
              </span>
            </li>
            <li className="flex items-start" data-id="element-211">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-212"></span>
              <span data-id="element-213">
                Zero calories, zero taste — Doesn't use up your limited calorie
                budget
              </span>
            </li>
            <li className="flex items-start" data-id="element-214">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-215"></span>
              <span data-id="element-216">Simple daily use — Just 1 dropper in any beverage</span>
            </li>
          </ul>
        </div>
        <div className="mt-8" data-id="element-217">
          <p className="text-base" data-id="element-218">
            Look—I get it. You've been burned by supplements before. You're
            skeptical. You should be.
          </p>
          <p className="mt-4 text-base" data-id="element-219">
            But this isn't some sketchy "miracle pill" or unproven formula.
          </p>
          <p className="mt-4 text-base" data-id="element-220">This is:</p>
          <ul className="mt-2 space-y-2" data-id="element-221">
            <li className="flex items-start" data-id="element-222">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-223"></span>
              <span data-id="element-224">Backed by decades of peer-reviewed research</span>
            </li>
            <li className="flex items-start" data-id="element-225">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-226"></span>
              <span data-id="element-227">Used by professional athletes for 20+ years</span>
            </li>
            <li className="flex items-start" data-id="element-228">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-229"></span>
              <span data-id="element-230">
                Specifically formulated for GLP-1 users in a usable liquid
                format
              </span>
            </li>
            <li className="flex items-start" data-id="element-231">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-232"></span>
              <span data-id="element-233">
                Already helping thousands of GLP-1 users see real results
              </span>
            </li>
            <li className="flex items-start" data-id="element-234">
              <span className="w-1.5 h-1.5 rounded-full bg-green-600 mt-2 mr-3 flex-shrink-0" data-id="element-235"></span>
              <span data-id="element-236">Simple to use—just 1 dropper per day</span>
            </li>
          </ul>
        </div>
        <p className="mt-6 text-base" data-id="element-237">
          The science works. The format works. The only question is whether
          you'll act before it's too late.
        </p>
        <p className="mt-4 text-base" data-id="element-238">
          Learn more about the liquid HMB solution that's already helping
          thousands of GLP-1 users protect their muscle and transform the right
          way.
        </p>
        <p className="mt-4 text-base font-medium" data-id="element-239">
          Your transformation—your REAL transformation—starts with this
          decision.
        </p>
        <div className="mt-6 text-center" data-id="element-240">
          <p className="text-base font-medium" data-id="element-241">
            — Jessica Torres
            <br data-id="element-242" />
            Independent Health Investigator
            <br data-id="element-243" />
            Exposing What Big Pharma Hides
          </p>
        </div>
        {/* Final CTA Button */}
        <div className="mt-8" data-id="element-244">
          <CTAButton text="DISCOVER THE LIQUID HMB SOLUTION NOW ►" data-id="element-245" />
          <p className="mt-4 text-sm text-center" data-id="element-246">
            Join thousands of GLP-1 users who are losing fat (not muscle) with
            this simple daily solution.
          </p>
        </div>
      </main>
    </div>;
}